<zwi-main-wrapper>
  <zwi-main-content>
    <div class="zwi-section">
      <zwi-back-headline (navigateBack)="navigateToSettings()">Email</zwi-back-headline>
      <zwi-account-form></zwi-account-form>
    </div>
  </zwi-main-content>
</zwi-main-wrapper>
